import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchEventById(id) {
  const { data } = await http(`/admin/event/${id}`);

  return data;
}

export function useEventById(id) {
  const { data, ...raResult } = useQuery(["event-detail", id], () =>
    fetchEventById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
